
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.55 18.55"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"18.55","height":"18.55","rx":"3","fill":"#05123d"}}),_c('path',{attrs:{"d":"M14.39 4.17c-2.06 2.31-4.45 5-6.58 7.34L4.27 8.17l-1.4 1.82 4.29 4.06.76.71.7-.77c2.28-2.56 5-5.57 7.29-8.13z","fill":"#fff"}})])
          )
        }
      }
    